export default "__VITE_ASSET__CtIR7Dgc__"